import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
} from "./api";

const path = "admin/employees";

export const listEmployees = (page = 0, pageSize = 20) =>
  getRequest(
    `${path}?page=${page}&pageSize=${pageSize}&sortBy=userInfo.firstName&order=ASC`,
    true,
  );
export const createEmployee = (payload) => postRequest(path, payload, true);
export const getEmployee = (id) => getRequest(`${path}/${id}`, true);
export const updateEmployee = (id, payload) =>
  putRequest(`${path}/${id}`, payload, true);
export const deactivateEmployee = (id) => deleteRequest(path, id);
export const activateEmployee = (id) => patchRequest(`${path}/${id}/activate`);
export const resetEmployeePassword = (id, password) =>
  putRequest(`${path}/${id}/password`, { password }, true);
export const getMyEmployeeProfile = () => getRequest("admin/me", true);
export const updateMyEmployeePassword = (currentPassword, newPassword) =>
  putRequest("admin/me/password", { currentPassword, newPassword }, true);
